import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer } from "redux-persist";

// Persist configuration
const persistConfig = {
    key: "addToCart", // the key for the persisted slice in storage
    storage,
    whitelist: ["add-to-cart"], // Only persist userDetails
    version: 1,
};

const INTIALVALUE = {
    centreName: "",
    centreId: "",
    centreAddress: "",
    centreTest: [],
};

const AddToCartSlice = createSlice({
    name: "addToCart",
    initialState: {
        addProducts: INTIALVALUE, // Create a `userInfo` object to store user details separately
    },
    reducers: {
        addProducts: (state, action) => {
            const existingCentreTest = state.addProducts.centreTest || []; // Default to an empty array if it doesn't exist
            state.addProducts = {
                ...state.addProducts, // Spread existing properties (centreId, centreName, etc.)
                centreName: action.payload.centreName,
                centreId: action.payload.centreId,
                centreTest: [
                    ...existingCentreTest,
                    ...action.payload.centreTest,
                ], // Append new tests to existing tests
            };
        },

        removeFromCart: (state, action) => {
            // Remove the product from the cart
            state.addProducts.centreTest =
                state?.addProducts?.centreTest?.filter(
                    (product) => product?.itemId !== action.payload
                );
        },

        replaceCart: (state, action) => {
            state.addProducts = action.payload;
        },

        clearAllCart: (state) => {
            state.addProducts = INTIALVALUE;
        },
        logout: (state) => {
            state.userInfo = INTIALVALUE;
        },
    },
});

export const {
    addProducts,
    removeFromCart,
    replaceCart,
    clearAllCart,
    logout,
} = AddToCartSlice.actions;
// Wrap the UserReducer with persistReducer
const persistedUserReducer = persistReducer(
    persistConfig,
    AddToCartSlice.reducer
);

export const AddToCartReducer = persistedUserReducer;
